import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import ToggleArchivedButton from 'Components/ComponentLibrary/Molecules/ToggleArchivedButton';
import useResource from 'Hooks/useResource';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import { noop } from 'Helpers/PropTypes';

const useStyles = buildUseStyles('ThreadToggleArchivedButton', () => ({
  root: {},
}));

const ThreadToggleArchivedButton = ({
  className,
  resource,
  color,
  size,
  onChange,
  fullWidth,
  showLabel,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const ATTR_NAME = 'isArchived';
  const { refreshThreads } = useMessagesContext();
  const { setAttribute, resource: threadResource } = useResource(resource);

  const handleClick = async (event, value) => {
    event.preventDefault();
    event.stopPropagation();
    onChange();
    setAttribute(ATTR_NAME, value);
    await resource.submit();
    await refreshThreads();
  };

  return (
    <ToggleArchivedButton
      className={classNames(className, classes.root)}
      value={threadResource.isTruthy('isArchived')}
      onChange={handleClick}
      color={color}
      size={size}
      fullWidth={fullWidth}
      showLabel={showLabel}
    />
  );
};

ThreadToggleArchivedButton.defaultProps = {
  className: '',
  color: 'primary',
  size: 'default',
  onChange: noop,
  fullWidth: false,
  showLabel: false,
};

ThreadToggleArchivedButton.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  color: PropTypes.string,
  size: PropTypes.string,
  onChange: PropTypes.func,
  fullWidth: PropTypes.bool,
  showLabel: PropTypes.bool,
};

export { ThreadToggleArchivedButton };
